import { createSlice, createAsyncThunk, PayloadAction } from "@reduxjs/toolkit";
import { RootState } from "../../store";
import { fetchApi } from "../../../helper/fetchApi";
import { toDateRev } from "../../../helper/formatData";
import { loginDataAsync } from "../user/userSlice";

//interface
interface intInitSearch {
    id_location: number; //lokaliacja przedmiotu
    //(= 0) wszystkie lokalizacje
    //(> 0) wybrana lokalizacja
    status: string; //status umowy
    start: string; //wyszukaj po czasie dodania
    stop: string; //wyszukaj po czasie dodania
    text: string; //wyszukaj po tekscie w polach
    interval: number; //paginacja strony
}
//interface
export interface intInitState {
    data: {
        data: {
            amount: 0;
            data: Array<any>;
        };
        // client: {
        //     id: number;
        //     firstname: string;
        //     surname: string;
        //     nrDow: string;
        //     pesel: string;
        //     address: string;
        //     phone: string;
        //     notes: string;
        // };
        // item: Array<any>;
    };
    search: intInitSearch;
    filter: string;
    source: string;
    status: {
        statusAgreeP: string;
        statusAgreePupdate: string;
    };
    modal: {
        modalShowSP: boolean;
    };
    page: number;
}

//init state
const initialState: intInitState = {
    data: {
        data: {
            amount: 0,
            data: [],
        },
        // client: {
        //     id: 0,
        //     firstname: "",
        //     surname: "",
        //     nrDow: "",
        //     pesel: "",
        //     address: "",
        //     phone: "",
        //     notes: "",
        // },
        // item: [],
    },
    filter: "",
    source: "",
    search: {
        id_location: 0,
        status: "all",
        start: "2022-06-01",
        stop: toDateRev(),
        text: "",
        interval: 0,
    },
    status: {
        statusAgreeP: "init",
        statusAgreePupdate: "init",
    },
    modal: {
        modalShowSP: false,
    },
    page: 0,
};
//------------------------------------------------------------
//interface for request
interface IsearchAgreeDataAsync {
    driver: {
        //sterowanie strumieniem php
        ps: "P" | "S"; //umowy przedwstepne lub skupu
    };
    search: intInitSearch;
}
//fetch async data GET
export const searchAgreeDataAsync = createAsyncThunk(
    "agreeStateP/searchAgreeDataAsync",
    async (data: { data: IsearchAgreeDataAsync; access_token: string }, { rejectWithValue }) => {
        try {
            const response = await fetchApi(`/agree/rows`, data.data, data.access_token);
            return response;
        } catch (err: any) {
            return rejectWithValue(err.response.data);
        }
    }
);
//-------------------------------------------------------------
//interface for request
interface IupdateAgreeDataAsync {
    driver: {
        //sterowanie strumieniem php
        ps: string; //umowy przedwstepne lub skupu
        id: number; //id umowy, (= 0) new record, (> 0) update record
    };
    data: {
        //dane umowy do save lub update
        id_location?: number; //id lokalizacji
        client?: any; //json format
        item?: any; //json format
        proc?: number; //oprocentowanie
        term?: any; //termin gwarancji przytrzymania
        notes?: any; //notatki
        status: string; //zmiana statusu
    };
    search: intInitSearch;
}
//fetch async data from a server SAVE/UPDATE
export const updateAgreeDataAsync = createAsyncThunk(
    "/agreeStateP/updateAgreeDataAsync",
    async (data: { data: IupdateAgreeDataAsync; access_token: string }, { rejectWithValue }) => {
        try {
            const response = await fetchApi("/agree/update", data.data, data.access_token);
            return response;
        } catch (err: any) {
            return rejectWithValue(err.response.data);
        }
    }
);
//----------------------------------------------------------
//create slice obj
export const agreeSliceP = createSlice({
    name: "agreeStateP",
    initialState,
    reducers: {
        // setClientData: (state, action: PayloadAction<any>) => {
        //     const client = JSON.parse(action.payload);
        //     state.data.client = client;
        // },
        // setItemData: (state, action: PayloadAction<any>) => {
        //     const item = JSON.parse(action.payload);
        //     state.data.item = item;
        // },
        setStatus: (state, action: PayloadAction<any>) => {
            state.status.statusAgreeP = action.payload;
        },
        setStatusUpdate: (state, action: PayloadAction<any>) => {
            state.status.statusAgreePupdate = action.payload;
        },
        resetData: (state) => {
            state.data = initialState.data;
        },
        resetFilter: (state) => {
            state.filter = initialState.filter;
        },
        resetSearch: (state) => {
            state.search = initialState.search;
        },

        // setFilter: (state, action: PayloadAction<any>) => {
        //     state.filter = action.payload;
        // },
        setSearch: (state, action: PayloadAction<any>) => {
            state.search = action.payload;
        },
        // setSource: (state, action: PayloadAction<any>) => {
        //     state.source = action.payload;
        // },
        setModalShowSP: (state, action: PayloadAction<any>) => {
            state.modal.modalShowSP = action.payload;
        },
        //setup startu paginacji i limitu dla widoku
        setPageData: (state, action: PayloadAction<any>) => {
            state.page = action.payload;
        },
    },
    extraReducers: (builder) => {
        builder
            //ROWS
            .addCase(searchAgreeDataAsync.pending, (state) => {
                state.status.statusAgreeP = "load";
            })
            .addCase(searchAgreeDataAsync.fulfilled, (state, action) => {
                //success connection?
                try {
                    //success login?
                    if (action.payload.active) {
                        const data = action.payload.data;
                        state.data.data.amount = data.amount;
                        state.data.data.data = data.data.map((x: any) => {
                            return {
                                ...x,
                                client: JSON.parse(x.client),
                                item: JSON.parse(x.item),
                            };
                        });
                        state.status.statusAgreeP = "success";
                    } else {
                        state.data = initialState.data;
                        state.status.statusAgreeP = "unsuccess";
                    }
                } catch (err) {
                    state.status.statusAgreeP = "failed";
                    console.log("TypeError: JsonError when attempting resolve data.");
                }
            })
            .addCase(searchAgreeDataAsync.rejected, (state) => {
                state.status.statusAgreeP = "failed";
                console.log("TypeError: NetworkError when attempting to fetch resource.");
            })
            //UPDATE
            .addCase(updateAgreeDataAsync.pending, (state) => {
                state.status.statusAgreePupdate = "load";
            })
            .addCase(updateAgreeDataAsync.fulfilled, (state, action) => {
                //success connection?
                try {
                    //success login?
                    if (action.payload.active) {
                        const data = action.payload.data;
                        state.data.data.amount = data.amount;
                        state.data.data.data = data.data.map((x: any) => {
                            return { ...x, client: JSON.parse(x.client), item: JSON.parse(x.item) };
                        });
                        state.status.statusAgreePupdate = "success";
                    } else {
                        state.status.statusAgreePupdate = "unsuccess";
                    }
                } catch (err) {
                    state.status.statusAgreePupdate = "failed";
                    console.log("TypeError: JsonError when attempting resolve data.");
                }
            })
            .addCase(updateAgreeDataAsync.rejected, (state) => {
                state.status.statusAgreePupdate = "failed";
                console.log("TypeError: NetworkError when attempting to fetch resource.");
            })
            //SETUP ID LOCATION
            .addCase(loginDataAsync.fulfilled, (state, action) => {
                try {
                    if (action.payload.active) {
                        //full update
                        const data = action.payload;
                        state.search.id_location = data.user.id_location;
                    }
                } catch (err) {}
            });
    },
});
//create actions obj
export const {
    // setClientData,
    // setItemData,
    setStatus,
    setStatusUpdate,
    resetData,
    // setFilter,
    resetFilter,
    setSearch,
    resetSearch,
    // setSource,
    setPageData,
    setModalShowSP,
} = agreeSliceP.actions;

//get data from store
export const selectData = (state: RootState) => state.agreeStateP.data;
export const selectStatus = (state: RootState) => state.agreeStateP.status;
export const selectSearchData = (state: RootState) => state.agreeStateP.search;
export const selectFilterData = (state: RootState) => state.agreeStateP.filter;
export const selectPageData = (state: RootState) => state.agreeStateP.page;
export const selectSource = (state: RootState) => state.agreeStateP.source;
export const selectModalStatus = (state: RootState) => state.agreeStateP.modal;

//create reducer
export default agreeSliceP.reducer;
